import React, { useEffect, useRef } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import xeroService from '../../../services/xeroService';
import { toast } from 'react-toastify';

const XeroRedirect = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const isProcessing = useRef(false);

    useEffect(() => {
        const handleAuthorization = async () => {
            // Prevent multiple calls
            if (isProcessing.current) {
                return;
            }
            isProcessing.current = true;

            try {
                const code = searchParams.get('code');
                const state = searchParams.get('state');
                const sessionState = searchParams.get('session_state');

                if (!code || !state || !sessionState) {
                    throw new Error('Authorization code not found');
                }

                // Call your API to handle the authorization
                const response = await xeroService.getAccessToken({ code, state, sessionState });
                
                toast.success('Xero authorization successful', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });

                // Redirect back to Xero settings page
                navigate('/xero_settings');
            } catch (error) {
                console.error('Authorization error:', error);
                toast.error(error.message || 'Failed to authorize Xero', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
                navigate('/xero_settings');
            }
        };

        handleAuthorization();
    }, [searchParams, navigate]);

    return (
        <div className="d-flex justify-content-center align-items-center p-5">
            <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
            <div className="ms-3">
                <h5 className="mb-0">Authorizing Xero...</h5>
                <small className="text-muted">Please wait while we authorize Xero</small>
            </div>
        </div>
    );
}

export default XeroRedirect;